import React from 'react';

function TermsOfService() {
    return (
        <div className="bg-white py-12 md:py-16 px-4">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">Terms of Service</h1>
                <p className="text-gray-600 mb-8">Last Updated: August 21, 2025</p>
                
                <div className="prose prose-lg max-w-none text-gray-700">
                    <p>
                        Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the Faster Bike Taxi mobile application and website (the "Service") operated by Faster Bike Taxi ("us", "we", or "our").
                    </p>
                    <p className="my-4">
                        Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.
                    </p>
                    <p className="my-4">
                        By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Use of Our Services</h2>
                    <p>
                        The Faster Bike Taxi application ("App") provides a platform for users to arrange and schedule transportation services with independent third-party providers of such services.
                    </p>
                    <p className="my-4">
                        You may be required to register an account to access and use our services. You must provide accurate, current, and complete information during the registration process and keep your account information up-to-date.
                    </p>
                    <p className="my-4">
                        You are responsible for safeguarding the password and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">User Conduct</h2>
                    <p>
                        You agree not to engage in any of the following prohibited activities:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>Using the service for any illegal purpose or in violation of any local, state, national, or international law</li>
                        <li>Harassing, threatening, intimidating, or causing distress or discomfort to any other user of our Service or drivers</li>
                        <li>Impersonating any person or entity or falsely stating or otherwise misrepresenting your affiliation with a person or entity</li>
                        <li>Interfering with or disrupting the Service or servers or networks connected to the Service</li>
                        <li>Attempting to gain unauthorized access to parts of the Service that are restricted</li>
                        <li>Using the Service in a way that could damage, disable, overburden, or impair it</li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Payment Terms</h2>
                    <p>
                        The use of our Services may require payment of fees. All fees are quoted in Indian Rupees and are inclusive of applicable taxes unless otherwise stated.
                    </p>
                    <p className="my-4">
                        You agree to pay all fees associated with the services you request. Payment can be made through the payment methods made available in the App.
                    </p>
                    <p className="my-4">
                        We reserve the right to modify our pricing at any time. We will provide you with notice of any price changes by updating the prices in the App.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Cancellation Policy</h2>
                    <p>
                        Users may cancel ride requests before the driver arrives at the pickup location. However, a cancellation fee may apply if you cancel after a certain time or if the driver has already traveled a significant distance to your location.
                    </p>
                    <p className="my-4">
                        The specific cancellation fee will be displayed in the App at the time of cancellation and will be based on factors such as the time elapsed since the ride was requested and the distance the driver has traveled.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Intellectual Property</h2>
                    <p>
                        The Service and its original content, features, and functionality are and will remain the exclusive property of Faster Bike Taxi and its licensors. The Service is protected by copyright, trademark, and other laws.
                    </p>
                    <p className="my-4">
                        Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Faster Bike Taxi.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Limitation of Liability</h2>
                    <p>
                        In no event shall Faster Bike Taxi, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>Your access to or use of or inability to access or use the Service</li>
                        <li>Any conduct or content of any third party on the Service</li>
                        <li>Any content obtained from the Service</li>
                        <li>Unauthorized access, use, or alteration of your transmissions or content</li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Disclaimer</h2>
                    <p>
                        Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied.
                    </p>
                    <p className="my-4">
                        Faster Bike Taxi and its subsidiaries, affiliates, and licensors do not warrant that:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>The Service will function uninterrupted, secure, or available at any particular time or location</li>
                        <li>Any errors or defects will be corrected</li>
                        <li>The Service is free of viruses or other harmful components</li>
                        <li>The results of using the Service will meet your requirements</li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Changes to Terms</h2>
                    <p>
                        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
                    </p>
                    <p className="my-4">
                        By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Contact Us</h2>
                    <p>
                        If you have any questions about these Terms, please contact us:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>By email: legal@fasterbiketaxi.com</li>
                        <li>By phone: (123) 456-7890</li>
                        <li>By mail: 123 Main Street, Bangalore, India</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default TermsOfService;
